import { jsx } from 'react/jsx-runtime';
import { MenuItem } from '@sgcmpteltd/uikit-react';
import Link from 'next/link';
import { useMemo } from 'react';
import { s as styleInject } from './style-inject.es-Bff-fD1R.js';

var css_248z = ".SGCM_UIKIT_NEXT_MenuItem_text_1h0im_1 {\n  line-height: 18px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGlCQUFpQjtBQUNuQiIsImZpbGUiOiJzdHlsZXMubW9kdWxlLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIudGV4dCB7XG4gIGxpbmUtaGVpZ2h0OiAxOHB4O1xufSJdfQ== */";
var styles = {"text":"SGCM_UIKIT_NEXT_MenuItem_text_1h0im_1"};
styleInject(css_248z);

const IMSUserMenuItem = ({ link, title }) => {
    const isActive = useMemo(() => {
        const currentUrlObj = new URL(window.location.href);
        // Handle relative URLs by providing the base URL
        const itemUrlObj = new URL(link, window.location.origin);
        return (currentUrlObj.pathname === itemUrlObj.pathname);
    }, [link]);
    return (jsx(MenuItem, { isActive: isActive, onClick: () => {
            window.open(link, '_self', 'noreferrer noopener');
        }, children: jsx(Link, { className: styles.text, href: link, prefetch: false, children: title }) }));
};

export { IMSUserMenuItem as I };
//# sourceMappingURL=component-jZRYP_hw.js.map
